export default __webpack_public_path__ + "static/media/02_jnj.ac5c87ae.png";